import { RootState } from "../../../../models";
import { AuthenticationState, BankId } from "../../../../models/state";
import { State as AccountState } from "../../checkout/state/selectors/accountSelectors";

export type State = Pick<RootState, "authentication"> & AccountState;
export const getAuthentication = (state: State): AuthenticationState | undefined => state.authentication;

// Telia Login
export const isAuthenticated = (state: State): boolean => !!getAuthentication(state)?.isAuthenticated;

// BankId Authentication
export const getBankId = (state: State): BankId | undefined => getAuthentication(state)?.bankId;
export const getBankIdUrl = (state: State): string | undefined => getBankId(state)?.url;
export const isBankIdVerified = (state: State): boolean => !!getBankId(state)?.verified;
export const isBankIdPerformed = (state: State): boolean => !!getBankId(state)?.performed;
export const isBankIdAvailable = (state: State): boolean => !!getBankId(state)?.available;
export const isBankIdMandatory = (state: State): boolean => !!getBankId(state)?.mandatory;
export const hasBankIdError = (state: State): boolean => !!getBankId(state)?.error;
export const getBankIdErrorMessage = (state: State): string | undefined => getBankId(state)?.errorMessage;
export const shouldShowBankId = (state: State): boolean => {
    return isBankIdAvailable(state) && !hasBankIdError(state) && !isBankIdVerified(state) && !!getBankIdUrl(state);
};

// User Authentication by BankID
export const getCustomer = (state: State): string | undefined => {
    const customer = getBankId(state)?.customer;
    if (customer) {
        return `${customer.firstName} ${customer.lastName}`;
    }
};

export const getRequestor = (state: State): string | undefined => getAuthentication(state)?.requestor;
